import { render, staticRenderFns } from "./VTabsHash.vue?vue&type=template&id=6b611279&lang=pug"
import script from "./VTabsHash.vue?vue&type=script&lang=ts"
export * from "./VTabsHash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabs})
